import { render, staticRenderFns } from "./cebsbInfoData.vue?vue&type=template&id=669b6455&scoped=true&"
import script from "./cebsbInfoData.vue?vue&type=script&lang=js&"
export * from "./cebsbInfoData.vue?vue&type=script&lang=js&"
import style0 from "./cebsbInfoData.vue?vue&type=style&index=0&id=669b6455&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "669b6455",
  null
  
)

export default component.exports